// Ranking de vendedores del Home: quien más vendió arriba. Lógica pura, sin React.
import type { SellerKpiRow } from '@/api/services/retail-org/backoffice';

/** Monto desc, luego piezas desc; quien no vendió queda al final por nombre. */
export function sortSellers(rows: SellerKpiRow[]): SellerKpiRow[] {
    return [...rows].sort(
        (a, b) =>
            (b.soldTodayCents ?? 0) - (a.soldTodayCents ?? 0) ||
            (b.unitsToday ?? 0) - (a.unitsToday ?? 0) ||
            a.name.localeCompare(b.name, 'es-MX'),
    );
}
